/**
 * Single source for the commercial terms that are stated in more than one
 * place. Reference these constants, never retype the wording.
 */

/** How fees carry forward. Published verbatim wherever the credit is described. */
export const CREDIT_RULE =
  "The Operating Diagnostic fee is credited in full against the Full Diagnostic if you proceed within 30 days";


/** How long a client commits for. Published verbatim wherever the term is described. */
export const TERM_RULE =
  "Engagements are committed one quarter at a time, with a review point at each 90-day boundary";

/** What Ajility delivers and reviews by the 90-day mark. Published verbatim wherever the 90-day standard is described. */
export const NINETY_DAY_STANDARD =
  "Within the first 90 days Ajility delivers clear priorities, execution discipline and operational visibility, then reviews progress with the leadership team at the 90-day boundary";

/** How the 90-Day Operating System Install is paid and where the exit point sits. Published verbatim. */
export const NINETY_DAY_INSTALL_TERMS =
  "Paid in three instalments: the Full Diagnostic fee at signing, then two equal instalments at the Week 3 gate and at Week 9. If the Week 3 report and plan do not persuade you to continue, you stop there, you keep the plan, and you owe nothing beyond the Full Diagnostic fee";

/** The renew-or-exit sentence published beside the retainers. */
export const RENEW_OR_EXIT =
  "Retainers are committed one quarter at a time and reviewed at each 90-day boundary: renew or exit. There is no lock-in and no retainer that quietly becomes eighteen months";

/** Scope exclusion. Published verbatim wherever the boundary of our advice is described. */
export const SCOPE_EXCLUSION =
  "Ajility provides operational and management consulting only. We do not provide accounting, tax, legal, audit, valuation, financial product or lending advice, and nothing we provide should be treated as any of those. Where a matter falls outside our scope we will say so and refer you to a licensed adviser.";

/** No reliance disclaimer. Published verbatim wherever site material is described as general information. */
export const NO_RELIANCE =
  "Material on this site, including articles, benchmarks and the results of the Operating Scan, is general information about business operations. It does not take account of your particular circumstances and should not be relied on as advice. Obtain your own advice before acting on it.";

/** Liability cap. Published verbatim wherever liability is described. */
export const LIABILITY_CAP =
  "To the maximum extent permitted by law, our total liability arising out of or in connection with an engagement is limited, at our option, to resupplying the services or paying the cost of having the services supplied again, or to the fees paid to us for that engagement. Nothing in these terms excludes, restricts or modifies any guarantee, right or remedy under the Australian Consumer Law that cannot lawfully be excluded.";

/** Client indemnity. Published verbatim wherever the client's responsibility for input accuracy is described. */
export const CLIENT_INDEMNITY =
  "You agree to indemnify us against loss arising from information you provide that is incomplete, inaccurate or misleading, and from any decision you take that departs from our written recommendations.";
